// extracted by mini-css-extract-plugin
export default {"wrap":"pG-z","fullWidth":"qG-z","hideOnDesktop":"rG-z","content":"sG-z","hasOpenedNav":"tG-z","crumbsList":"uG-z","dropdownsWrap":"vG-z"};